import {
	initAnimationScripts,
	initAlwaysRunScriptsChild,
	initParentScripts,
	initSliderScriptChild,
} from './functions';

(() => {
	window.addEventListener('DOMContentLoaded', () => {
		initParentScripts();
		initAlwaysRunScriptsChild();
		initAnimationScripts();
		initSliderScriptChild();
	});
})();

import WebGl from './webGl2/main';
new WebGl('.js-webgl');